import router from './router'
import store from './store'
import { getStudentId, getOpenId, getName } from './utils/auth'
import { getIsJoinApi } from '@/api/clock'
import Vue from "vue"
import { Toast } from 'vant';
Vue.use(Toast);
import { Dialog } from 'vant';
Vue.use(Dialog);

function getQueryVariable(variable) {
    var s = window.location.href
    var query = s.substring(s.indexOf('?') + 1, s.length);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { 
            return pair[1]; 
        }
    }
    return (false);
}

router.beforeEach(async (to, from, next) => {
    // next()
    document.title = to.meta.title
    if (to.path == "/") { //如果去的是首页，发送湖区用户信息然后存储
        await store.dispatch('app/getUserInfo')
        next()
    } else if (to.path == "/record" || to.path == "/report/list") { //如果去的是视力档案||视力报告
        let studentId = getStudentId()
        if (studentId == "" || String(studentId) == "undefined") { //没绑跳转绑定页面
            next({ name: "StudentBinding", query: { name: to.name } })
        } else {
            next()
        }
    } else if (to.path == "/clock") {
        let str = window.location.href;
        let clock = str.indexOf('clock');
        if (clock != -1 && getQueryVariable("openId") && getQueryVariable("studentId") && getQueryVariable("name") && getQueryVariable('one')) {//通过分享进入页面截取openId和studentId和学生姓名和one
            store.commit('app/SET_OPENID', getQueryVariable("openId"))
            store.commit('app/SET_STUDENTID', getQueryVariable("studentId"))
            store.commit('app/SET_NAME', decodeURI(getQueryVariable("name")))
            document.title = `帮${decodeURI(getQueryVariable("name"))}打卡`
            next()
        } else if (clock != -1 && getQueryVariable("openId") && getQueryVariable("studentId") && getQueryVariable("name")) {//点击推送打卡异常消息
            store.commit('app/SET_OPENID', getQueryVariable("openId"))
            store.commit('app/SET_STUDENTID', getQueryVariable("studentId"))
            store.commit('app/SET_NAME', decodeURI(getQueryVariable("name")))
            next()
        } else {
            let studentId1 = getStudentId()
            if (studentId1 == "" || String(studentId1) == "undefined") { //没绑跳转绑定页面
                next({ name: "StudentBinding", query: { name: to.name } })
            } else {
                getIsJoinApi({ //判断学生有没有参加打卡活动
                    studentId: studentId1
                }).then((res) => {
                    if (res.data.isJoin) {//有直接进
                        next()
                    } else { //没有去主页面
                        Dialog.alert({
                            title: '该学生未参加打卡活动',
                        }).then(() => {
                            // on close
                            next('/')
                        });
                    }
                })
            }
        }
    } else { //去的别的页面直接通过
        next()
    }
})

